// extracted by mini-css-extract-plugin
module.exports = {"uploadedDocCard":"UploadedDocument_uploadedDocCard__RG5ip","left":"UploadedDocument_left__xO34_","right":"UploadedDocument_right__3oenV"};